// extracted by mini-css-extract-plugin
module.exports = {"detection-result-modal":"detection-result-modal___1pi1_"};